module.exports = __webpack_public_path__ + "static/media/DSTV.5a39667d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/discos/DSTV.svg
// module id = 383
// module chunks = 25